import { ReactNode } from 'react';
// re-export from radix slot component
export * from '@radix-ui/react-slot';

export const getSlot = (items: ReactNode[], SlotComponent: any) =>
  items.find(
    (child: any) =>
      child.type && child.type.displayName && child.type.displayName === SlotComponent.displayName,
  ) as React.ReactNode | undefined;
